export default {
  getPatientUsers: state => state.patientUsers,
  getSinglePatientUser: state => state.singlePatientUser
}
